import { MessageSquare, ListChecks, Calculator } from "lucide-react";

/* ---------------- grading helpers ---------------- */
export const optPts = (score, full) => (score >= 3 ? full : score === 1 ? Math.round(full / 2) : 0);

export const gradeNumber = (answer, correct, full) => {
  const a = parseFloat(answer);
  if (isNaN(a) || !(correct > 0)) return { band: "wrong", pts: 0 };
  const err = Math.abs(a - correct) / correct;
  if (err <= 0.02) return { band: "correct", pts: full };
  if (err <= 0.2) return { band: "partial", pts: Math.round(full / 2) };
  return { band: "wrong", pts: 0 };
};

export const gradeChips = (chips, selected, max) => {
  const trueIdx = chips.map((x, i) => (x.flag ? i : -1)).filter((i) => i >= 0);
  const caught = trueIdx.filter((i) => selected.has(i)).length;
  const falseTaps = [...selected].filter((i) => !chips[i].flag).length;
  const penalty = Math.max(3, Math.round(max / 5));
  const pts = Math.max(0, Math.min(max, Math.round((max * caught) / (trueIdx.length || 1)) - penalty * falseTaps));
  return { pts, caught, total: trueIdx.length, falseTaps };
};

export const beatMax = (beat) => {
  if (beat.type === "choice") return beat.full ?? 20;
  if (beat.type === "multi") return beat.max ?? 20;
  if (beat.type === "order") return beat.full ?? 25;
  if (beat.type === "assemble") return beat.full ?? 30;
  if (beat.type === "cpr") return beat.full ?? 20;
  if (beat.type === "crashtrolley") return beat.full ?? 20;
  if (beat.type === "sterilefield") return beat.full ?? 20;
  if (beat.type === "instruments") return beat.full ?? 20;
  if (beat.type === "autoclave") return beat.max ?? beat.full ?? 20;
  if (beat.type === "exposure") return beat.full ?? 20;
  if (beat.type === "alara") return beat.max ?? beat.full ?? 20;
  if (beat.type === "positioning") return beat.full ?? 20;
  if (beat.type === "counttray") return beat.full ?? 20;
  if (beat.type === "floorplan") return beat.full ?? 20;
  if (beat.type === "number") return (beat.fields || []).reduce((a, f) => a + (f.full ?? 10), 0);
  return 20;
};

export const tidy = (n) => (n == null || isNaN(n) ? "—" : parseFloat(Number(n).toFixed(3)).toString());

export const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

export const serveCase = (c) => ({
  ...c,
  beats: c.beats.map((b) => {
    if (b.type === "choice") return { ...b, options: shuffle(b.options) };
    if (b.type === "multi") return { ...b, chips: shuffle(b.chips) };
    return b;
  }),
});

export const pickRandom = (cases, excludeId) => {
  const pool = cases.filter((c) => c.id !== excludeId);
  const list = pool.length ? pool : cases;
  return list[Math.floor(Math.random() * list.length)];
};

export const ICON_BY_TYPE = { choice: MessageSquare, multi: ListChecks, number: Calculator };

export const band = (p) =>
  p >= 80
    ? { label: "Competent", text: "text-emerald-600", ring: "border-emerald-300 bg-emerald-50", bar: "#10b981" }
    : p >= 60
    ? { label: "Developing", text: "text-amber-600", ring: "border-amber-300 bg-amber-50", bar: "#f59e0b" }
    : { label: "Not yet competent", text: "text-rose-600", ring: "border-rose-300 bg-rose-50", bar: "#ef4444" };
